import React from 'react';
import { Pagination } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const CustomPagination = ({ currentPage, totalPages, onPageChange, loading = false, compact = false }) => {

    // Returns page numbers with "ellipsis" markers, e.g. [1,2,3,4,5,"…",25].
    const getPaginationNumbers = () => {
        const pageButtonsToShow = window.innerWidth < 576 ? 3 : 5;

        if (totalPages <= pageButtonsToShow + 2) {
            return Array.from({ length: totalPages }, (_, i) => i + 1);
        }

        const halfRange = Math.floor(pageButtonsToShow / 2);
        let startPage = Math.max(currentPage - halfRange, 1);
        let endPage = startPage + pageButtonsToShow - 1;

        if (endPage > totalPages) {
            endPage = totalPages;
            startPage = endPage - pageButtonsToShow + 1;
        }

        const pages = Array.from(
            { length: endPage - startPage + 1 },
            (_, i) => startPage + i
        );

        // Always expose the first and last page as jump targets.
        if (startPage > 1) {
            if (startPage > 2) pages.unshift("start-ellipsis");
            pages.unshift(1);
        }
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) pages.push("end-ellipsis");
            pages.push(totalPages);
        }

        return pages;
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };

    const paginationNumbers = getPaginationNumbers();

    return (
        <>
            {totalPages > 1 &&
                <div className={`d-flex align-items-center justify-content-end${compact ? ' custom-pagination-compact' : ''}`}>
                    <button
                        className='border-0 bg-transparent d-flex align-items-center custom-pagination-arrow'
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1 || loading}
                        aria-label="Previous page"
                    >
                        <FontAwesomeIcon icon={faChevronLeft} />
                    </button>

                    <Pagination className="d-flex mb-0">
                        {paginationNumbers.map(page =>
                            typeof page === "string" ? (
                                <span key={page} className="custom-pagination-ellipsis">…</span>
                            ) : (
                                <Pagination.Item
                                    key={page}
                                    active={page === currentPage}
                                    disabled={loading}
                                    onClick={() => onPageChange(page)}
                                >
                                    {page}
                                </Pagination.Item>
                            )
                        )}
                    </Pagination>

                    <button
                        className='border-0 bg-transparent d-flex align-items-center custom-pagination-arrow'
                        onClick={handleNextPage}
                        disabled={currentPage === totalPages || loading}
                        aria-label="Next page"
                    >
                        <FontAwesomeIcon icon={faChevronRight} />
                    </button>
                </div>
            }
        </>
    );
};

export default CustomPagination;
